module.exports = __webpack_public_path__ + "img/icon-4.10a062d2.webp";